import { INavRequestOption } from '../../nav/model/nav-request-option.interface';

export const MENU_WANT_PROTECTED_ROUTE =        'MENU_WANT_PROTECTED_ROUTE';
export const MENU_SHOW_NAV_SEARCH =             'MENU_SHOW_NAV_SEARCH';

// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

export function menuWantProtectedRoute(route: string) {
  return { type: MENU_WANT_PROTECTED_ROUTE, route: route };
}

export function menuShowNavSearch(showNavMenu: boolean) {
  return { type: MENU_SHOW_NAV_SEARCH, payload: {show: showNavMenu} };
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/menu/store/actions.ts